import { COMMISSION_GROUP_USER_GROUP } from "localConstants.ts";

import CommissionGroupDataOptional = App.Data.CommissionGroupDataOptional;

export const userGroup: CommissionGroupDataOptional = {
    id: COMMISSION_GROUP_USER_GROUP,
    title: "general.default_user_group",
    number_of_partners: 0,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    description: "",
};
